import { AssistantsEndpoints, assistantsFetchJson } from './assistantsApiClient';

/**
 * @returns {Promise<Array<Record<string, unknown>>>}
 */
export async function getAgents() {
  const data = await assistantsFetchJson(AssistantsEndpoints.AGENTS);
  return data.agents || [];
}
